import { render, staticRenderFns } from "./TransactionReverseForm.vue?vue&type=template&id=22733454&scoped=true"
import script from "./TransactionReverseForm.vue?vue&type=script&lang=js"
export * from "./TransactionReverseForm.vue?vue&type=script&lang=js"
import style0 from "./TransactionReverseForm.vue?vue&type=style&index=0&id=22733454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22733454",
  null
  
)

export default component.exports